import { LogoFileExtntionRequest, LogoFileExtntionResponse } from '../../views/Profile/AddRestaurant';
import { apiSlice } from '../apiSlice';
import { CreateCustomizeMenuItem, CustomMenuImageUpdateRequest, CustomMenuListResponse, UpdateCustomizeMenuItem } from '../customizeMenuSlice';
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;
export const menuItemService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    createCustomMenuItem: builder.mutation<string, CreateCustomizeMenuItem>({
      query: (data) => ({
        url: `https://adminhttps-createcustommenu${API_BASE_DOMAIN}/`,
        method: 'POST',
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    fetchCustomMenuList: builder.query<CustomMenuListResponse, string>({
      query: (restaurantId) => ({
        url: `https://adminhttps-getcustommenulistbyrestaurantid${API_BASE_DOMAIN}/?restaurantId=${restaurantId}`,
        method: 'GET',

      }),
    }),

    updateCustomMenuItem: builder.mutation<void, UpdateCustomizeMenuItem>({
      query: (data) => ({
        url: `https://adminhttps-updatecustommenu${API_BASE_DOMAIN}/`,
        method: 'PUT',
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),


    deleteCustomMenuItem: builder.mutation<void, { restaurantId: string, customMenuId: string }>({
      query: (requestData) => ({
        url: `https://adminhttps-deletecustommenu${API_BASE_DOMAIN}/`,
        method: 'DELETE',
        body: requestData,
        responseHandler: (response) => response.text(),
      }),
    }),

    UploadCustomizeMenuLogoFileExtntionHttps: builder.mutation<
      LogoFileExtntionResponse,
      LogoFileExtntionRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-getcustommenuimageuploadurl${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
      }),
    }),

    updateCustomMenuImage: builder.mutation<any, CustomMenuImageUpdateRequest>({
      query: (requestData) => ({
        url: `https://adminhttps-updatecustommenuimage${API_BASE_DOMAIN}/`,
        method: "POST",
        body: requestData,
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const {
  useCreateCustomMenuItemMutation,
  useFetchCustomMenuListQuery,
  useLazyFetchCustomMenuListQuery,
  useUpdateCustomMenuItemMutation,
  useDeleteCustomMenuItemMutation,
  useUploadCustomizeMenuLogoFileExtntionHttpsMutation,
  useUpdateCustomMenuImageMutation
} = menuItemService;
